export default function LazyLoadImages() {
  observeImages()
}

function observeImages() {
  if(document.readyState !== 'loading') {
    startLazyload();
  } else {
    //Lazy Img sources or sourc sets using attr 'data-'prefixed versions of the attribute
    document.addEventListener("DOMContentLoaded", function () {
      startLazyload();
    });
  }
}

function startLazyload() {
  var lazyloadSrcs = document.querySelectorAll("[data-src]");

  var obseverOptions = {
    rootMargin: '350px', //magic number (of how far off the page it will define as 'observable'), 350px seems to work nicely
  }

  var srcObserver = new IntersectionObserver(function (entries) {

    entries.forEach(function (entry) {

      if (entry.isIntersecting) { //what we do when we 'observe' an image come into view
        var image = entry.target;
        image.src = image.dataset.src;
        image.removeAttribute('data-src');

        //check for srcsets in parent <picture> tag
        var parent = image.parentElement;
        if (parent.tagName == 'PICTURE') {
          var childSources = parent.getElementsByTagName('source');
          var childSourceElems = Array.prototype.slice.call(childSources, 0);
          childSourceElems.forEach(function (childSource) { //loop though source elems replacing data-srcsets
            childSource.srcset = childSource.dataset.srcset;
            childSource.removeAttribute('data-srcset');
          });
        }

        image.classList.remove("blur");
        srcObserver.unobserve(image);
      }

    });

  }, obseverOptions);

  lazyloadSrcs.forEach(function (image) {
    srcObserver.observe(image); //observe our images, wait for them to come into view
  });
}
